<template>
	<div class="dv-popup" :class="{'is-relative':isRelative}">
			<div class="inner-body" :name="'dv-popup-'+uid">
		    <span class="icon">
			    <svg width="16" height="16"
			         xmlns="http://www.w3.org/2000/svg" ><path d="M11.824 1.3c-.111 0-.167 0-.21.021a.201.201 0 00-.088.087c-.022.043-.022.1-.022.212v.76c0 .112 0 .168.021.21.02.038.05.068.087.088.043.022.1.022.212.023.251.002.353.008.434.024a1.3 1.3 0 011.021 1.021c.022.109.025.256.025.754v.803c0 .562 0 .992.126 1.391.11.352.293.677.534.955a2.5 2.5 0 00.38.351 2.5 2.5 0 00-.38.35 2.699 2.699 0 00-.534.956c-.127.4-.127.83-.126 1.39v.804c0 .498-.003.645-.025.754a1.3 1.3 0 01-1.021 1.021c-.081.016-.183.022-.434.024-.113.001-.17.001-.212.023a.199.199 0 00-.087.088c-.021.042-.021.098-.021.21v.76c0 .112 0 .169.022.211.02.038.05.069.088.088.043.022.099.021.21.02.277-.001.502-.01.707-.05a2.7 2.7 0 002.121-2.122c.052-.263.052-.56.052-.956v-.78c0-.7.008-.897.06-1.063a1.3 1.3 0 01.258-.46c.114-.133.279-.242.875-.608l.015-.01A.2.2 0 0016 8.494v-.968-.018a.2.2 0 00-.088-.158l-.007-.004-.008-.005c-.596-.366-.76-.476-.875-.608a1.3 1.3 0 01-.258-.46c-.052-.166-.06-.364-.06-1.063v-.78c0-.395 0-.693-.052-.956a2.7 2.7 0 00-2.121-2.121 3.8 3.8 0 00-.707-.052zM4.18 1.3c.111 0 .167 0 .21.021a.2.2 0 01.088.087c.022.043.022.1.022.212v.76c0 .112 0 .168-.022.21a.2.2 0 01-.086.088c-.043.022-.1.022-.212.023a2.456 2.456 0 00-.434.024 1.3 1.3 0 00-1.021 1.021c-.022.109-.025.256-.025.754v.803c0 .562 0 .992-.126 1.391a2.7 2.7 0 01-.534.955A2.5 2.5 0 011.659 8a2.5 2.5 0 01.38.35 2.7 2.7 0 01.535.956c.127.4.126.83.126 1.39v.804c0 .498.003.645.025.754a1.3 1.3 0 001.021 1.021c.081.016.183.022.434.024.113.001.17.001.212.023a.2.2 0 01.086.088c.022.042.022.098.022.21v.76c0 .112 0 .169-.022.211a.2.2 0 01-.088.088c-.043.022-.099.021-.21.02a3.796 3.796 0 01-.707-.05 2.7 2.7 0 01-2.121-2.122c-.052-.263-.052-.56-.052-.956v-.78c0-.7-.008-.897-.06-1.063a1.3 1.3 0 00-.258-.46C.868 9.135.703 9.026.107 8.66a.2.2 0 01-.103-.167v-.968-.018a.2.2 0 01.088-.158c.004-.002.008-.004.015-.01.596-.365.76-.475.875-.607a1.3 1.3 0 00.258-.46c.052-.166.06-.364.06-1.063v-.78c0-.395 0-.693.052-.956a2.7 2.7 0 012.121-2.121A3.8 3.8 0 014.18 1.3zM8 9a1 1 0 100-2 1 1 0 000 2z"></path><path d="M12.2 8a1 1 0 11-2 0 1 1 0 012 0zM4.8 9a1 1 0 100-2 1 1 0 000 2z"></path>
			    </svg>
		    </span>
		</div>
		<tippy :to="'dv-popup-'+uid" theme="transparent" :flip="true" boundary="window"
		       :sticky="true" :flipOnUpdate="true" placement="bottom-start"
		        :hideOnClick="false" interactive="true" interactiveBorder="0" >
			<grouped-list :options="optionGroups" @change="valueChanged"></grouped-list>
		</tippy>
	</div>
</template>

<script>
let id = 0;
    import API from "@/api"
    import GroupedList from "@/components/base/grouped-list";
    export default {
      name: "DVPopup",
	    components: {GroupedList},
	    mixins: [API],
        props: {
	        isRelative: {
	        	default: false,
		        type: Boolean,
	        },
	        isPage: {
	        	default: false,
		        type: Boolean
	        }
        },
        data() {
		      	id+=1;
            return {
            	value: "",
            	uid: id,
            }
        },
	    computed:{
		    products(){
			    return this.$store.state.page.products;
		    },
		    sortedProducts() {
			    function compare(a, b) {
				    if (a['order_index'] < b['order_index']) return -1;
				    if (a['order_index'] > b['order_index']) return 1;
				    return 0;
			    }
			    return this.products.sort(compare);
		    },
		    optionGroups() {
		    	if (this.isPage) {
				    let data = [
					    {id:"contact", name:"Contact details", options: [
							    // {id:"contact.id", name:"ID"},
							    {id:"contact.email", name:"Email"},
							    {id:"contact.first_name", name:"First name"},
							    {id:"contact.last_name", name:"Last name"},
							    {id:"contact.full_name", name:"Full name"},

							    {id:"contact.country", name:"Country"},
							    {id:"contact.city", name:"City"},
							    {id:"contact.zip", name:"Zip"},
							    {id:"contact.state", name:"State"},
							    {id:"contact.address", name:"Address"},

							    {id:"contact.shipping_country", name:"Shipping country"},
							    {id:"contact.shipping_city", name:"Shipping city"},
							    {id:"contact.shipping_zip", name:"Shipping zip"},
							    {id:"contact.shipping_state", name:"Shipping state"},
							    {id:"contact.shipping_address", name:"Shipping address"},

							    {id:"contact.ip", name:"IP address"},
						    ]},
					    {id:"order", name:"Order details", options: [
							    {id:"order.id", name:"Order number"},
							    {id:"order.time", name:"Time"},
							    {id:"order.ref", name:"Payment reference"},
							    {id:"order.source", name:"Payment method"},
							    //  TODO: not supported by backend yet.
							    // {id:"order.qty", name:"Quantity"},
							    {id:"order.amount", name:"Amount"},
						    ]},
					    {id:"query", name:"UTM tags", options: [
							    {id:"query.utm_id", name:"utm_id"},
							    {id:"query.utm_source", name:"utm_source"},
							    {id:"query.utm_medium", name:"utm_medium"},
							    {id:"query.utm_campaign", name:"utm_campaign"},
							    {id:"query.utm_term", name:"utm_term"},
							    {id:"query.utm_content", name:"utm_content"},
						    ]},
					    {id:"funnel", name:"Funnel", options: [
							    {id:"core.currency", name:"Currency symbol"},
							    {id:"core.currency_code", name:"Currency code"},
						    ]},
				    ];
				    // TODO: support dynamic products
				    // let products = [];
				    // this.sortedProducts.forEach(x => {
				    // 	products.push({id:`core.product(${x.id})`, name:x.name,
						//     options: [
						// 	    {id:`core.product(${x.id}).name`, name:"Product name"},
						// 	    {id:`core.product(${x.id}).price`, name:"Product price"},
						//     ]});
				    //
				    // })
				    // data.push( {id:"products", name:"Products", options: products})
				    return data;
			    }

		    	return [
				        {id:"contact", name:"Contact details", options: [
						    {id:"contact.id", name:"ID"},
						    {id:"contact.first_name", name:"First name"},
						    {id:"contact.last_name", name:"Last name"},
						    {id:"contact.full_name", name:"Full name"},

						    {id:"contact.country", name:"Country"},
						    {id:"contact.city", name:"City"},
						    {id:"contact.zip", name:"Zip"},
						    {id:"contact.state", name:"State"},
						    {id:"contact.address", name:"Address"},

						    {id:"contact.shipping_country", name:"Shipping country"},
						    {id:"contact.shipping_city", name:"Shipping city"},
						    {id:"contact.shipping_zip", name:"Shipping zip"},
						    {id:"contact.shipping_state", name:"Shipping state"},
						    {id:"contact.shipping_address", name:"Shipping address"},

						    {id:"contact.ip", name:"IP address"},
					    ]},
				        {id:"order", name:"Order details", options: [
						    {id:"order.id", name:"Order number"},
						    {id:"order.time", name:"Time"},
						    {id:"order.ref", name:"Payment reference"},
						    {id:"order.source", name:"Payment source"},
						    //  TODO: not supported by backend yet.
						    // {id:"order.qty", name:"Quantity"},
						    {id:"order.amount", name:"Amount"},
					    ]},
			    ];
		    }
	    },
        methods: {
		        valueChanged(field) {
		        	if (!field) return;

		          this.$emit("change", field.item.id, field.item.name.toLowerCase());
			      },
            closePopup() {
                this.$emit("close");
            },
        }
    }
</script>
<style lang="scss">
    .dv-popup {
	    top: 3px;right: -10px;
	    //position: absolute;
	    background-color: #fff;
	    color: #000;
	    max-width: 300px;
	    padding: 1px;
	    box-shadow: 0 4px 14px 0 rgba(0,0,0,.2), 0 0 0 1px rgba(0,0,0,.05);
	    white-space: nowrap;
	    border-radius: 4px;
	    background-clip: padding-box;
	    font-size: 14px;
	    line-height: 22px;
	    z-index: 3;
	    width: auto;
	    cursor: pointer;
	    position: sticky;
	    float: right;
	    margin-right: -12px;
	    outline: none !important;

	    .inner-body {
		    outline: none !important;
		    background: white;
		    color: #fff;
		    width: 30px;
		    height: 24px;
		    position: absolute;
		    padding: 1px;
		    box-shadow: 0 4px 14px 0 rgba(0,0,0,.2), 0 0 0 1px rgba(0,0,0,.05);
		    white-space: nowrap;
		    border-radius: 4px;
		    background-clip: padding-box;
		    font-size: 14px;
		    line-height: 22px;
		    z-index: 3;
		    text-align: center;
		    &:before {
			    position: absolute;
			    display: block;
			    margin: 0;
			    width: auto;
			    height: auto;
			    border: none;
			    background: 0 0;
			    font-size: 17px;
			    line-height: 19px;
			    top: 50%;
			    content: '\25B8';
			    transform: translateY(-50%) rotate(180deg);
			    margin-top: 1px;
			    left: -6px;
			    text-shadow: 1px -1px 6px rgba(0,0,0,.1);
			    color: #fff;
		    }
		    .icon {
			    padding: 1px 0;
			    display: inline-block;
			    vertical-align: bottom;
			    line-height: 20px;
			    > svg {
				    fill: #000;
				    width: 16px;
				    height: 16px;
				    display: inline-block;
				    vertical-align: bottom;
				    margin-bottom: 2px;
			    }
		    }
	    }
	    &:hover {
		    color: #4268df;
		    svg {
			    fill: #4268df !important;
		    }
	    }
	    &.is-relative {
		    position: relative;
		    top: 0;
		    right: 0;
		    margin: 0;
		    box-shadow: none;
		    float: none;
		    .inner-body {
			    box-shadow: none;
			    position: relative;
			    &:before {
				    display: none;
			    }
			    svg {
				    fill: #d2d5dc;
			    }
		    }
	    }
    }
</style>
